import {getActualRouter} from 'router/utils/defineActualRouter';
import handleRouterError from 'router/utils/handleRouterError';
import store from 'store';

const vueRouterProxy = () => ({

  routerModule () {
    return getActualRouter();
  },


  /**
   * Redirects user to specified url use only with backbone code which redirects by url
   * @param path - url to redirect
   * @param replace - if true -> change url without writing to history
   * @param trigger - from backbone docs `If you also wish to call the route function, set the trigger option to true`
   */
  navigate (path, {replace = false, trigger = false} = {}) {
    /*
     * a little bit dirty fix because vue router tries to match route rule with `path`
     * routes are specified without hash that's why `path` doesn't match any route
     * and it adds `path` after current route, it assumes `path` as hash
     */
    const fixedPath = path.replace('#', '');

    if (replace || !trigger) {
      return this.routerModule().replace(fixedPath).
        catch(handleRouterError);
    }

    this.routerModule().push(fixedPath).
      catch(handleRouterError);
  },

  navigatePrevious () {
    // clear vuex dirty tracker (only called from legacy frontend)
    store.commit('dirtyTracker/UNDIRTY_ALL');

    /*
     * route is unset or it has no name
     * route has no name if current route is first opened route
     */
    if (!store.getters['routing/prevRoute'] || !store.getters['routing/prevRoute'].name) {
      return false;
    }
    this.routerModule().replace(store.getters['routing/prevRoute']).
      catch(handleRouterError);
    return true;
  },

  showNotFound () {
    return this.routerModule().replace({name: '404page', params: {0: '/'}}).
      catch(handleRouterError);
  }
});

export default vueRouterProxy;
